export const indiaProducts = [
  'AWM',
  'SKS',
  'RSA',
  'PFG',
  'VST',
  'QYP',
  '1KL',
  '36S',
  'XGJ',
  'TT5',
]

export const rolesList = [
  { id: "architect", name: "role-architect", image: 'thumbnails/building-and-roles/Architect.png' },
  { id: "technical-consultant", name: "role-technical-consultant", image: 'thumbnails/building-and-roles/Technical consultant.png' },
  { id: "builder", name: "role-builder", image: 'thumbnails/building-and-roles/Builder.png' },
  { id: "facility-manager", name: "role-facility-manager", image: 'thumbnails/building-and-roles/Facility Manager.png' },
  { id: "building-manager", name: "role-building-manager", image: 'thumbnails/building-and-roles/Building manager.png' },
  { id: "government-and-municipalities", name: "role-government-and-municipalities", image: 'thumbnails/building-and-roles/Government and Municipalities.png' },
  { id: "building-owner", name: "role-building-owner", image: 'thumbnails/building-and-roles/Building Owner.png' },
  { id: "housing-and-owners-cooperation", name: "role-housing-and-owners-cooperation", image: 'thumbnails/building-and-roles/Housing - owners cooperation.png' },
  { id: "tenant", name: "role-tenant", image: 'thumbnails/building-and-roles/Tenant.png' },
  { id: "authorities-and-influencers", name: "role-authorities-and-influencers", image: 'thumbnails/building-and-roles/Authorities and Influencers.png' },
  { id: "sales", name: "role-sales", image: 'thumbnails/building-and-roles/Sales.png' },
  { id: "kone-distributor", name: "role-kone-distributor", image: 'thumbnails/building-and-roles/Kone distributor.png' },
  { id: "other-intrested", name: "role-other-interested", image: 'thumbnails/building-and-roles/Other intrested.png' },
]

export const titlesList = [
  {value: 'Mr.', text: 'title-mr'},
  {value: 'Ms.', text: 'title-ms'},
  {value: 'Mrs.', text: 'title-mrs'},
  {value: 'Mgr', text: 'title-mgr'},
  {value: 'Captain', text: 'title-captain'},
  {value: 'Dr.', text: 'title-dr'},
]

export const usStatesList = [
  {"name": "Alabama", "value": "AL"},
  {"name": "Alaska", "value": "AK"},
  {"name": "Arizona", "value": "AZ"},
  {"name": "Arkansas", "value": "AR"},
  {"name": "California", "value": "CA"},
  {"name": "Colorado", "value": "CO"},
  {"name": "Connecticut", "value": "CT"},
  {"name": "Delaware", "value": "DE"},
  {"name": "District Of Columbia", "value": "DC"},
  {"name": "Florida", "value": "FL"},
  {"name": "Georgia", "value": "GA"},
  {"name": "Hawaii", "value": "HI"},
  {"name": "Idaho", "value": "ID"},
  {"name": "Illinois", "value": "IL"},
  {"name": "Indiana", "value": "IN"},
  {"name": "Iowa", "value": "IA"},
  {"name": "Kansas", "value": "KS"},
  {"name": "Kentucky", "value": "KY"},
  {"name": "Louisiana", "value": "LA"},
  {"name": "Maine", "value": "ME"},
  {"name": "Maryland", "value": "MD"},
  {"name": "Massachusetts", "value": "MA"},
  {"name": "Michigan", "value": "MI"},
  {"name": "Minnesota", "value": "MN"},
  {"name": "Mississippi", "value": "MS"},
  {"name": "Missouri", "value": "MO"},
  {"name": "Montana", "value": "MT"},
  {"name": "Nebraska", "value": "NE"},
  {"name": "Nevada", "value": "NV"},
  {"name": "New Hampshire", "value": "NH"},
  {"name": "New Jersey", "value": "NJ"},
  {"name": "New Mexico", "value": "NM"},
  {"name": "New York", "value": "NY"},
  {"name": "North Carolina", "value": "NC"},
  {"name": "North Dakota", "value": "ND"},
  {"name": "Ohio", "value": "OH"},
  {"name": "Oklahoma", "value": "OK"},
  {"name": "Oregon", "value": "OR"},
  {"name": "Pennsylvania", "value": "PA"},
  {"name": "Rhode Island", "value": "RI"},
  {"name": "South Carolina", "value": "SC"},
  {"name": "South Dakota", "value": "SD"},
  {"name": "Tennessee", "value": "TN"},
  {"name": "Texas", "value": "TX"},
  {"name": "Utah", "value": "UT"},
  {"name": "Vermont", "value": "VT"},
  {"name": "Virginia", "value": "VA"},
  {"name": "Washington", "value": "WA"},
  {"name": "West Virginia", "value": "WV"},
  {"name": "Wisconsin", "value": "WI"},
  {"name": "Wyoming", "value": "WY"}
]

export const caTerritoriesList = [
  { "value": "AB", "name": "Alberta"},
  { "value": "BC", "name": "British Columbia"},
  { "value": "MB", "name": "Manitoba"},
  { "value": "NB", "name": "New Brunswick"},
  { "value": "NL", "name": "Newfoundland and Labrador"},
  { "value": "NS", "name": "Nova Scotia"},
  { "value": "NT", "name": "Northwest Territories"},
  { "value": "NU", "name": "Nunavut"},
  { "value": "ON", "name": "Ontario"},
  { "value": "PE", "name": "Prince Edward Island"},
  { "value": "QC", "name": "Québec"},
  { "value": "SK", "name": "Saskatchewan"},
  { "value": "YT", "name": "Yukon"}
]

export const countryISOMapping:any = {
  AF: 'AFG',
  AX: 'ALA',
  AL: 'ALB',
  DZ: 'DZA',
  AS: 'ASM',
  AD: 'AND',
  AO: 'AGO',
  AI: 'AIA',
  AQ: 'ATA',
  AG: 'ATG',
  AR: 'ARG',
  AM: 'ARM',
  AW: 'ABW',
  AU: 'AUS',
  AT: 'AUT',
  AZ: 'AZE',
  BS: 'BHS',
  BH: 'BHR',
  BD: 'BGD',
  BB: 'BRB',
  BY: 'BLR',
  BE: 'BEL',
  BZ: 'BLZ',
  BJ: 'BEN',
  BM: 'BMU',
  BT: 'BTN',
  BO: 'BOL',
  BA: 'BIH',
  BW: 'BWA',
  BV: 'BVT',
  BR: 'BRA',
  VG: 'VGB',
  IO: 'IOT',
  BN: 'BRN',
  BG: 'BGR',
  BF: 'BFA',
  BI: 'BDI',
  KH: 'KHM',
  CM: 'CMR',
  CA: 'CAN',
  CV: 'CPV',
  KY: 'CYM',
  CF: 'CAF',
  TD: 'TCD',
  CL: 'CHL',
  CN: 'CHN',
  HK: 'HKG',
  MO: 'MAC',
  CX: 'CXR',
  CC: 'CCK',
  CO: 'COL',
  KM: 'COM',
  CG: 'COG',
  CD: 'COD',
  CK: 'COK',
  CR: 'CRI',
  CI: 'CIV',
  HR: 'HRV',
  CU: 'CUB',
  CY: 'CYP',
  CZ: 'CZE',
  DK: 'DNK',
  DJ: 'DJI',
  DM: 'DMA',
  DO: 'DOM',
  EC: 'ECU',
  EG: 'EGY',
  SV: 'SLV',
  GQ: 'GNQ',
  ER: 'ERI',
  EE: 'EST',
  ET: 'ETH',
  FK: 'FLK',
  FO: 'FRO',
  FJ: 'FJI',
  FI: 'FIN',
  FR: 'FRA',
  GF: 'GUF',
  PF: 'PYF',
  TF: 'ATF',
  GA: 'GAB',
  GM: 'GMB',
  GE: 'GEO',
  DE: 'DEU',
  GH: 'GHA',
  GI: 'GIB',
  GR: 'GRC',
  GL: 'GRL',
  GD: 'GRD',
  GP: 'GLP',
  GU: 'GUM',
  GT: 'GTM',
  GG: 'GGY',
  GN: 'GIN',
  GW: 'GNB',
  GY: 'GUY',
  HT: 'HTI',
  HM: 'HMD',
  VA: 'VAT',
  HN: 'HND',
  HU: 'HUN',
  IS: 'ISL',
  IN: 'IND',
  ID: 'IDN',
  IR: 'IRN',
  IQ: 'IRQ',
  IE: 'IRL',
  IM: 'IMN',
  IL: 'ISR',
  IT: 'ITA',
  JM: 'JAM',
  JP: 'JPN',
  JE: 'JEY',
  JO: 'JOR',
  KZ: 'KAZ',
  KE: 'KEN',
  KI: 'KIR',
  KP: 'PRK',
  KR: 'KOR',
  KW: 'KWT',
  KG: 'KGZ',
  LA: 'LAO',
  LV: 'LVA',
  LB: 'LBN',
  LS: 'LSO',
  LR: 'LBR',
  LY: 'LBY',
  LI: 'LIE',
  LT: 'LTU',
  LU: 'LUX',
  MK: 'MKD',
  MG: 'MDG',
  MW: 'MWI',
  MY: 'MYS',
  MV: 'MDV',
  ML: 'MLI',
  MT: 'MLT',
  MH: 'MHL',
  MQ: 'MTQ',
  MR: 'MRT',
  MU: 'MUS',
  YT: 'MYT',
  MX: 'MEX',
  FM: 'FSM',
  MD: 'MDA',
  MC: 'MCO',
  MN: 'MNG',
  ME: 'MNE',
  MS: 'MSR',
  MA: 'MAR',
  MZ: 'MOZ',
  MM: 'MMR',
  NA: 'NAM',
  NR: 'NRU',
  NP: 'NPL',
  NL: 'NLD',
  AN: 'ANT',
  NC: 'NCL',
  NZ: 'NZL',
  NI: 'NIC',
  NE: 'NER',
  NG: 'NGA',
  NU: 'NIU',
  NF: 'NFK',
  MP: 'MNP',
  NO: 'NOR',
  OM: 'OMN',
  PK: 'PAK',
  PW: 'PLW',
  PS: 'PSE',
  PA: 'PAN',
  PG: 'PNG',
  PY: 'PRY',
  PE: 'PER',
  PH: 'PHL',
  PN: 'PCN',
  PL: 'POL',
  PT: 'PRT',
  PR: 'PRI',
  QA: 'QAT',
  RE: 'REU',
  RO: 'ROU',
  RU: 'RUS',
  RW: 'RWA',
  BL: 'BLM',
  SH: 'SHN',
  KN: 'KNA',
  LC: 'LCA',
  MF: 'MAF',
  PM: 'SPM',
  VC: 'VCT',
  WS: 'WSM',
  SM: 'SMR',
  ST: 'STP',
  SA: 'SAU',
  SN: 'SEN',
  RS: 'SRB',
  SC: 'SYC',
  SL: 'SLE',
  SG: 'SGP',
  SK: 'SVK',
  SI: 'SVN',
  SB: 'SLB',
  SO: 'SOM',
  ZA: 'ZAF',
  GS: 'SGS',
  SS: 'SSD',
  ES: 'ESP',
  LK: 'LKA',
  SD: 'SDN',
  SR: 'SUR',
  SJ: 'SJM',
  SZ: 'SWZ',
  SE: 'SWE',
  CH: 'CHE',
  SY: 'SYR',
  TW: 'TWN',
  TJ: 'TJK',
  TZ: 'TZA',
  TH: 'THA',
  TL: 'TLS',
  TG: 'TGO',
  TK: 'TKL',
  TO: 'TON',
  TT: 'TTO',
  TN: 'TUN',
  TR: 'TUR',
  TM: 'TKM',
  TC: 'TCA',
  TV: 'TUV',
  UG: 'UGA',
  UA: 'UKR',
  AE: 'ARE',
  GB: 'GBR',
  US: 'USA',
  UM: 'UMI',
  UY: 'URY',
  UZ: 'UZB',
  VU: 'VUT',
  VE: 'VEN',
  VN: 'VNM',
  VI: 'VIR',
  WF: 'WLF',
  EH: 'ESH',
  YE: 'YEM',
  ZM: 'ZMB',
  ZW: 'ZWE',
  XK: 'XKX'
}
